
<component :is="tag" class="icon" :class="[color, {'colorized': color !== null}]"></component>
